
import { IMonHocActionTypes } from "../../action-types/category/IMonHocActions";
import { IMonHocReducer } from "../../reducer-model/category/IMonHocReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IMonHocReducer = {
  status: eReducerStatusBase.is_not_initialization,
  monHocs: [],
  filter: {
    id_bm: 0,
    id_he: 0
  },
  selectedIds: []
};
export const monHocReducer = (
  state: IMonHocReducer = iniState,
  action: IMonHocActionTypes
): IMonHocReducer => {
  switch (action.type) {
    case "MON_HOC_LOAD_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
      };
    case "MON_HOC_LOAD_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        monHocs: action.payload,
      };
    case "MON_HOC_LOAD_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MON_HOC_SHOW_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: true,
        monHocEditing: action.payload
      };
    case "MON_HOC_CLOSE_EDIT_MODAL":
      return {
        ...state,
        isShowEditModal: false,
      };
    case "MON_HOC_SAVE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_saving,
      };
    case "MON_HOC_SAVE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
        isShowEditModal: false
      };
    case "MON_HOC_SAVE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MON_HOC_DELETE_START":
      return {
        ...state,
        status: eReducerStatusBase.is_deleting,
      };
    case "MON_HOC_DELETE_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_need_reload,
      };
    case "MON_HOC_DELETE_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    case "MON_HOC_CHANGE_FILTER":
      return {
        ...state,
        filter: action.payload,
      };
    case "MON_HOC_CHANGE_SELECTED_IDS":
      return {
        ...state,
        selectedIds: action.payload,
      };
    default:
      return state;
  }
};
